import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API, callAPI, callAPIWithoutAuth } from '../../utils/apiUtils';
import { apiUrls } from '../../utils/apiUrls';
import { SuccessMessage } from '../../components/common/Helper';

export const loginUser = createAsyncThunk(
  'auth/login',
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const response = await callAPIWithoutAuth(
        apiUrls?.login,
        {},
        "POST",
        { email: email, password: password }
      );

      if (response?.data?.status) {
        return response.data;
      } else {
        return rejectWithValue(response?.data?.message);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message);
    }
  }
);

export const sendOTP = createAsyncThunk(
  'auth/sendOTP',
  async (email, { rejectWithValue }) => {
    try {
      const response = await callAPIWithoutAuth(
        apiUrls?.signupOtp,
        {},
        "POST",
        { email }
      );

      if (response?.data?.status) {
        return response.data;
      } else {
        return rejectWithValue(response?.data?.message);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message);
    }
  }
);

export const verifyOTP = createAsyncThunk(
  'auth/verifyOTP',
  async ({ email, otp }, { rejectWithValue }) => {
    try {
      const response = await callAPIWithoutAuth(
        apiUrls?.verifysignupOtp,
        {},
        "POST",
        { email, otp }
      );

      if (response?.data?.status) {
        return response.data;
      } else {
        return rejectWithValue(response?.data?.message);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message);
    }
  }
);

export const signupUser = createAsyncThunk(
  'auth/signup',
  async ({ email, password, password_confirmation }, { rejectWithValue }) => {
    try {
      const response = await callAPIWithoutAuth(
        apiUrls?.setPassword,
        {},
        "POST",
        { email, password, password_confirmation }
      );

      if (response?.data?.status) {
        return response.data;
      } else {
        return rejectWithValue(response?.data?.message);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message);
    }
  }
);

export const deleteUser = createAsyncThunk(
  'auth/deleteAccount',
  async (_, { rejectWithValue }) => {
    try {
      const response = await callAPI(
        apiUrls?.deleteAccount,
        {},
        "GET",
        {}
      );

      if (response?.data?.status) {
        SuccessMessage(response.data.message)
        return response.data;
      } else {
        return rejectWithValue(response?.data?.message);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message);
    }
  }
);

export const updateProfile = createAsyncThunk(
  'auth/updateProfile',
  async (profileData, { rejectWithValue, getState }) => {
    try {
      const state = getState();

      const response = await API(
        `${apiUrls.editProfile}`,
        {},
        "POST",
        profileData
      );

      if (response?.data?.success) {
        SuccessMessage(response.data.message)
        return response.data.data.user;
      } else {
        return rejectWithValue(response?.data?.message);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message);
    }
  }
);
export const updateAddress = createAsyncThunk(
  'auth/updateAddress',
  async (profileData, { rejectWithValue, getState }) => {
    try {
      const response = await callAPI(
        `${apiUrls.adressUpdate}`,
        {},
        "POST",
        profileData
      );

      if (response?.data?.success) {
        SuccessMessage(response.data.message)
        return response.data.data?.adress || response.data.data;
      } else {
        return rejectWithValue(response?.data?.message);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message);
    }
  }
);

export const changePassword = createAsyncThunk(
  'auth/changePassword',
  async (passwordData, { rejectWithValue }) => {
    try {
      const response = await callAPI(
        apiUrls.changePassword,
        {},
        "POST",
        passwordData
      );

      if (response?.data?.success) {
        SuccessMessage(response.data.message)
        return response.data;
      } else {
        return rejectWithValue(response?.data?.message);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message);
    }
  }
);


export const forgotPasswordSendMail = createAsyncThunk(
  'auth/forgotPasswordSendMail',
  async (email, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('email', email);

      const response = await callAPIWithoutAuth(
        apiUrls.forgotPasswordSendMail,
        {},
        "POST",
        formData
      );

      if (response?.data?.success) {
        return response.data;
      } else {
        return rejectWithValue(response?.data?.message);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message);
    }
  }
);

export const forgotPasswordVerifyOTP = createAsyncThunk(
  'auth/forgotPasswordVerifyOTP',
  async ({ email, otp }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('email', email);
      formData.append('otp', otp);

      const response = await callAPIWithoutAuth(
        apiUrls.forgotPasswordVerifyOTP,
        {},
        "POST",
        formData
      );

      if (response?.data?.success) {
        return response.data;
      } else {
        return rejectWithValue(response?.data?.message);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message);
    }
  }
);

export const resetPassword = createAsyncThunk(
  'auth/resetPassword',
  async ({ email, password, password_confirmation }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('email', email);
      formData.append('password', password);
      formData.append('password_confirmation', password_confirmation);

      const response = await callAPIWithoutAuth(
        apiUrls.resetPassword,
        {},
        "POST",
        formData
      );

      if (response?.data?.success) {
        return response.data;
      } else {
        return rejectWithValue(response?.data?.message);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message);
    }
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: JSON.parse(localStorage.getItem("userData") || null),
    token: localStorage.getItem('accessToken') || null,
    loading: false,
    error: null,
    otpSent: false,
    otpVerified: false,
    currentStep: 1,
    updatingProfile: false,
    updatingAddress: false,
    updatingPassword: false,
    updateError: null,
    updateProfileSuccess: false,
    updateAddressSuccess: false,
    updatePasswordSuccess: false,
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.updatingProfile = false;
      state.updatingPassword = false;
      state.updateError = null;
      state.updateSuccess = false;
      localStorage.removeItem('accessToken');
      localStorage.removeItem('userData');
    },
    setAuthStep: (state, action) => {
      state.currentStep = action.payload;
    },
    clearError: (state) => {
      state.error = null;
      state.updateError = null;
    },
    setToken: (state, action) => {
      state.token = action.payload;
      localStorage.setItem('accessToken', action.payload);
    },
    setUser: (state, action) => {
      state.user = action.payload;
      localStorage.setItem('userData', JSON.stringify(action.payload));
    },
    clearUpdateStatus: (state) => {
      state.updateProfileSuccess = false;
      state.updateAddressSuccess = false;
      state.updatePasswordSuccess = false;
      state.updateError = null;
    },
    clearProfileUpdateStatus: (state) => {
      state.updateProfileSuccess = false;
    },
    clearAddressUpdateStatus: (state) => {
      state.updateAddressSuccess = false;
    },
    clearPasswordUpdateStatus: (state) => {
      state.updatePasswordSuccess = false;
    },
    toggleEditMode: (state, action) => {
      const { section, isEditing } = action.payload;
      state[`editing${section}`] = isEditing;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loginUser.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(loginUser.fulfilled, (state, action) => {
      state.loading = false;
      state.user = action.payload.data?.user;
      state.token = action.payload.data?.token;
      localStorage.setItem('accessToken', action.payload.data?.token);
      const userData = action.payload.data?.user;
      localStorage.setItem("userData", JSON.stringify(userData));
    });
    builder.addCase(loginUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(sendOTP.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(sendOTP.fulfilled, (state) => {
      state.loading = false;
      state.otpSent = true;
      state.currentStep = 2;
    });
    builder.addCase(sendOTP.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(verifyOTP.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(verifyOTP.fulfilled, (state) => {
      state.loading = false;
      state.otpVerified = true;
      state.currentStep = 3;
    });
    builder.addCase(verifyOTP.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(signupUser.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(signupUser.fulfilled, (state, action) => {
      state.loading = false;
      state.user = action.payload.data;
      state.token = action.payload.data?.token;
      localStorage.setItem('accessToken', action.payload.data?.token);
      localStorage.setItem('userData', JSON.stringify(action.payload.data));
    });
    builder.addCase(signupUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(updateProfile.pending, (state) => {
      state.updatingProfile = true;
      state.updateError = null;
      state.updateProfileSuccess = false;
    });
    builder.addCase(updateProfile.fulfilled, (state, action) => {
      state.updatingProfile = false;
      state.updateProfileSuccess = true;
      const existingAdress = state.user.adress || [];
      state.user = {
        ...state.user,
        ...action.payload,
        adress: existingAdress,
        full_name: action.payload.first_name && action.payload.last_name
          ? `${action.payload.first_name} ${action.payload.last_name}`
          : state.user.name
      };
      localStorage.setItem('userData', JSON.stringify(state.user));
    });

    builder.addCase(updateProfile.rejected, (state, action) => {
      state.updatingProfile = false;
      state.updateProfileSuccess = false;
      state.updateError = action.payload;
    });
    builder.addCase(changePassword.pending, (state) => {
      state.updatingPassword = true;
      state.updateError = null;
      state.updatePasswordSuccess = false;
    });
    builder.addCase(changePassword.fulfilled, (state) => {
      state.updatingPassword = false;
      state.updatePasswordSuccess = true;
    });
    builder.addCase(changePassword.rejected, (state, action) => {
      state.updatingPassword = false;
      state.updatePasswordSuccess = false;
      state.updateError = action.payload;
    });

    builder.addCase(updateAddress.pending, (state) => {
      state.updatingAddress = true;
      state.updateError = null;
      state.updateAddressSuccess = false;
    });

    builder.addCase(updateAddress.fulfilled, (state, action) => {
      state.updatingAddress = false;
      state.updateAddressSuccess = true;

      if (action.payload) {
        if (!state.user.adress) {
          state.user.adress = [];
        }
        const addressIndex = state.user.adress.findIndex(addr => addr.id === action.payload.id);
        if (addressIndex !== -1) {
          state.user.adress[addressIndex] = {
            ...state.user.adress[addressIndex],
            ...action.payload,
            updated_at: new Date().toISOString()
          };
        } else {
          state.user.adress.push({
            ...action.payload,
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString()
          });
        }
        localStorage.setItem('userData', JSON.stringify(state.user));
      }
    });
    builder.addCase(updateAddress.rejected, (state, action) => {
      state.updatingAddress = false;
      state.updateAddressSuccess = false;
      state.updateError = action.payload;
    });

    builder.addCase(deleteUser.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    builder.addCase(deleteUser.fulfilled, (state) => {
      state.loading = false;
      state.user = null;
      state.token = null;
      state.otpSent = false;
      state.otpVerified = false;
      state.currentStep = 1;
      state.updatingProfile = false;
      state.updatingAddress = false;
      state.updatingPassword = false;
      state.updateError = null;
      state.updateSuccess = false;
      localStorage.removeItem('accessToken');
      localStorage.removeItem('userData');
      window.location.href = '/';
    })
    builder.addCase(deleteUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    builder.addCase(forgotPasswordSendMail.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    builder.addCase(forgotPasswordSendMail.fulfilled, (state, action) => {
      state.loading = false;
      state.otpSent = true;
      if (state.currentStep === 1) {
        state.currentStep = 2;
      }
    })
    builder.addCase(forgotPasswordSendMail.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    builder.addCase(forgotPasswordVerifyOTP.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    builder.addCase(forgotPasswordVerifyOTP.fulfilled, (state, action) => {
      state.loading = false;
      state.otpVerified = true;
      if (state.currentStep === 2) {
        state.currentStep = 3;
      }
    })
    builder.addCase(forgotPasswordVerifyOTP.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    builder.addCase(resetPassword.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    builder.addCase(resetPassword.fulfilled, (state, action) => {
      state.loading = false;
      state.otpSent = false;
      state.otpVerified = false;
      state.currentStep = 1;
    })
    builder.addCase(resetPassword.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })

  }
});

export const { logout,
  setAuthStep,
  clearError,
  setToken,
  setUser,
  clearUpdateStatus,
  clearProfileUpdateStatus,
  clearAddressUpdateStatus,    
  clearPasswordUpdateStatus,
  toggleEditMode } = authSlice.actions;
export default authSlice.reducer;